import React from "react";
import Backdrop from "@mui/material/Backdrop";
import { useAppContext } from "../context/AppContext";
import MainLoader from "./MainLoader";

const LoadingModal = () => {
  const modalStyle = {
    zIndex: 9999,
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.6)",
    backdropFilter: "blur(6px)",
  };

  const { isLoading } = useAppContext();

  return (
    <Backdrop open={isLoading} style={modalStyle}>
      <MainLoader size={80} text="Synchronizing Data" />
    </Backdrop>
  );
};

export default LoadingModal;
